<template>
	<b-container fluid>
		<b-row id="dayNamesRow" class="my-4 text-center">
			<b-col>Monday</b-col>
			<b-col>Tuesday</b-col>
			<b-col>Wednesday</b-col>
			<b-col>Thursday</b-col>
			<b-col>Friday</b-col>
		</b-row>

		<b-container v-if="dayGrid !== null" fluid>
			<b-row v-for="week in dayGrid.length" :key="week" no-gutters class='my-2'>
				<b-col v-for="day in 5" :key="day" lg>
					<Day
						v-if="dayGrid[week - 1][day - 1] !== 'x'"
						:day="
							dayGrid[week - 1][day - 1] === 'x'
								? 0
								: parseInt(dayGrid[week - 1][day - 1])
						"
						:month="month"
						:year="year"
					/>
					<Day v-else :day="0" />
				</b-col>
			</b-row>
		</b-container>

		<b-container v-else fluid>
			<h1>Loading</h1>
		</b-container>
	</b-container>
</template>

<script>
import Day from "@/components/MedExOnline/Day.vue"

// 6 -> 06
function padWithZero(day) {
	if (day.length === 1) {
		return "0" + day
	} else {
		return day
	}
}

export default {
	name: "Month",
	props: {
		month: {
			type: Number,
			required: true,
		},
		year: {
			type: Number,
			required: true,
		},
	},
	components: {
		Day,
	},
	computed: {
		gridOffset: function() {
			// date with month and year from props
			var date = new Date(this.year, this.month, 1)
			let x
			switch (date.getDay()) {
				// Weekday
				case 1:
				case 2:
				case 3:
				case 4:
				case 5:
					x = date.getDay() - 1
					break
				// Sunday
				case 0:
					x = 0
					break
				// Saturday
				case 6:
					x = 0
					break
			}
			return x
		},
		firstBDayOffset: function() {
			// date with month and year from props
			var date = new Date(this.year, this.month, 1)
			let x

			switch (date.getDay()) {
				// Weekday
				case 1:
				case 2:
				case 3:
				case 4:
				case 5:
					x = 0
					break

				// Sunday
				case 0:
					x = 1
					break
				// Saturday
				case 6:
					x = 2
					break
			}

			return x
		},
		lastDayOfMonth: function() {
			return new Date(this.year, this.month + 1, 0).getDate()
		},
		dayGrid: function() {
			let grid = []
			let week = []
			let date

			// append offset days to grid
			if (this.gridOffset) {
				for (var k = 0; k < this.gridOffset; k++) {
					week.push("x")
				}
			}

			for (var i = 1 + this.firstBDayOffset; i <= this.lastDayOfMonth; i++) {
				date = new Date(this.year, this.month, i)

				// only append business days to week
				if (date.getDay() !== 0 && date.getDay() !== 6) {
					week.push(padWithZero(i.toString()))
				} else {
					continue
				}

				// if end of month has been reached, pad current week if necessary and push to month
				if (i === this.lastDayOfMonth) {
					while (week.length < 5) {
						week.push("x")
					}
					grid.push(week)
				}
				// append week to month if it has reached 5 days
				else if (week.length === 5) {
					grid.push(week)
					week = [] // reset after pushing week into month
				}
			}
			return grid
		}
	},
}
</script>

<style scoped>
@media screen and (max-width: 992px) {
	#dayNamesRow {
		display: none;
	}
}
</style>
